<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">амбулаторный прием и часы обслуживания</h3>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                        <col style="width: calc(100% / 4)">
                    </colgroup>
                    <thead>
                        <tr>
                            <th colspan="2">категория</th>
                            <th colspan="2">часы амбулаторного приема и обслуживания</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="2">заявка на обслуживание</td>
                            <td rowspan="2">будние дни</td>
                            <td>утро</td>
                            <td>08:30 ~ 11:45</td>
                        </tr>
                        <tr>
                            <td>полдень</td>
                            <td>12:30 ~ 16:45</td>
                        </tr>
                        <tr>
                            <td rowspan="2">часы обслуживания</td>
                            <td rowspan="2">будние дни</td>
                            <td>утро</td>
                            <td>09:00 ~ 12:00</td>
                        </tr>
                        <tr>
                            <td>полдень</td>
                            <td>13:00 ~ 17:00</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="mt10 font-sub">
                ※ Нерабочий день – суббота.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        mounted() {
        },
    }
</script>